import { useQuery } from '@apollo/client';

import useAdminDashboard from '@/views/AdminDashboard/hooks/useAdminDashboard';
import GET_FEATURE_FLAG from '@/views/AdminDashboard/hooks/useFlagOrganization/graphql/GetFlagOrganization.v4.b2b.graphql';
import type {
  GetFlagOrganization,
  GetFlagOrganizationVariables,
} from '@/views/AdminDashboard/hooks/useFlagOrganization/graphql/types/GetFlagOrganization';

export const useGetFlagOrganization = () => {
  const { slug } = useAdminDashboard();
  const { data, loading } = useQuery<
    GetFlagOrganization,
    GetFlagOrganizationVariables
  >(GET_FEATURE_FLAG, {
    context: {
      clientName: 'v4.b2b',
    },
    variables: {
      slug,
    },
  });

  const talentSuiteFlag = data?.b2bOrganizationCurrent?.features?.find(
    feature => feature?.slug === 'talent-suite',
  );

  return {
    isFullSuite: !!talentSuiteFlag,
    isLoading: loading,
  };
};
